/**
 * Chameleon - client-only plugin
 *
 * Injects the Chameleon script directly into the document to avoid Nuxt 4 / Unhead v2
 * head management issues (Capo.js, useHead script handling).
 * User identification (chmln.identify) is called in app.vue when authenticated.
 */
import {defineNuxtPlugin} from '#app';

const CHAMELEON_SCRIPT = `!function(d,w){var t="SB87zfHKy67ev9F15y5gDIHR3g1xlXLmsCsZt0MG9TFCi1-1Sb1eB-FbrjybsIg4NveEVU",c="chmln",i=d.createElement("script");if(w[c]||(w[c]={}),!w[c].root){w[c].accountToken=t,w[c].location=w.location.href.toString(),w[c].now=new Date,w[c].fastUrl='https://fast.chameleon.io/';var m="identify alias track clear set show on off custom help _data".split(" ");for(var s=0;s<m.length;s++){!function(){var t=w[c][m[s]+"_a"]=[];w[c][m[s]]=function(){t.push(arguments);};}();}i.src=w[c].fastUrl+"messo/"+t+"/messo.min.js",i.async=!0,d.head.appendChild(i);}}(document,window);`;

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  const config = useRuntimeConfig();
  if (config.public.e2eVisualTest) return;

  const script = document.createElement('script');
  script.textContent = CHAMELEON_SCRIPT;
  document.head.appendChild(script);
});
